/*!
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';
import { PERMISSIONS } from '../../../constants/APP_CONSTANTS';
import CourseDetailsHeader from "./CourseDetailsHeader";
import {COURSE_DETAILS} from "../../constants/constants";
import {CourseDetailsDatePicker} from "./CourseDetailsDatePicker";
import Svg from '../../widgets/Svg/Svg';

export default class CourseDetails extends Component {
    constructor(props) {
        super(props);
        this.state = { reloadKeyForDateChange: 0, instructor_name: {} };
    }
    static get propTypes() {
        return {
            registrarCourseSectionDetails: PropTypes.array.isRequired,
            setComponent: PropTypes.func,
            guardDirtySetActive: PropTypes.func,
            guardDirtyIsActive: PropTypes.bool,
            courseChangesDetails: PropTypes.object,
            addNewInstructorCourseDetails:PropTypes.func,
            showExistsMessage:PropTypes.func,
            hasPrivateResources:PropTypes.bool
        };
    }

    componentDidMount() {
        if (typeof this.props.setComponent === 'function') {
            this.props.setComponent("CourseDetails");
        }
        this.props.getCourseDetails(this.props.match.params.collId);
    }

    componentDidUpdate(prevProps, prevState) {
        const isRender = prevProps.registrarCourseSectionDetails.some((course, index) => {
            return course.endDate !== this.props.registrarCourseSectionDetails[index].endDate;
        });
        if (isRender) {
            this.setState((state) => {
                return { reloadKeyForDateChange: state.reloadKeyForDateChange + 1 };
            });
        }
    }

    courseEndDateChangeHandler = (changeDate, courseId, index) => {
        const endDate = `${Moment(changeDate).format("YYYY-MM-DD")}T00:00:00.000Z`;
        this.props.guardDirtySetActive(true);
        this.props.changeCourseEndDate({ endDate, courseId, index});
        this.setState((state) => {
            return { reloadKeyForDateChange: state.reloadKeyForDateChange + 1 };
        });
    }

    instructorChangeHandler = (e, courseId) => {
        e.persist();
        this.setState((state) => ({ instructor_name: { ...state.instructor_name, [courseId]: e.target.value.trim() } }));
    }

    clearInstructorName = (courseId) => {
        this.setState((state) => ({ instructor_name: { ...state.instructor_name, [courseId]: '' } }));
    }

    addNewInstructorName(courseId ,index) {
        let { instructor_name } = this.state;
        let collectionId = this.props.match.params.collId;
        let isUserNameExists = this.props.registrarCourseSectionDetails[index].instructors.some(instructor =>
            (instructor.username === instructor_name[courseId]));
        if (!isUserNameExists) {
            this.props.addNewInstructorCourseDetails({ instructor_name: [instructor_name[courseId]], courseId, collectionId });
            this.clearInstructorName(courseId);
        } else {
            this.props.showExistsMessage({ messageKey: 'instructor_exists_msg', type: 'error' });
        }
    }
    render() {
        return (<div className='course-details-page'>
            <div className='pe-row'>
                <div className="pe-col-12">
                    <div className='header-margin' >
                        <label className="pe-title--small">Course Details</label>
                    </div>
                </div>
            </div>
            {this.props.registrarCourseSectionDetails.map((courses,index)=> (<CourseDetailsHeader key={`courses_${index}`} courseSectionDetails={courses}>
                <div className="course-details">
                    <div className="pe-row">
                        <div className="pe-col-6">
                            <label className="pe-label--bold">{COURSE_DETAILS.COURSE_ID} </label>
                        </div>
                        <div className="pe-col-6">
                            <label className="pe-label">{courses.id}</label>
                        </div>
                    </div>
                    <div className="pe-row">
                        <div className="pe-col-6">
                            <label className="pe-label--bold">{COURSE_DETAILS.COURSE_STATUS}</label>
                        </div>
                        <div className="pe-col-6">
                            <label className="pe-label first-charupper">{courses.sectionStatus?courses.sectionStatus:''}</label>
                        </div>
                    </div>
                    <div className="pe-row alignitem-center">
                        <div className="pe-col-6">
                            <label className="pe-label--bold">{`${COURSE_DETAILS.INSTRUCTOR}${courses.hasOwnProperty('instructors') && courses.instructors.length>1?'s':''} :`}</label>
                        </div>
                        <div className="pe-col-6">
                            <ul className="instructor-list">
                                {courses.hasOwnProperty('instructors') && courses.instructors.map((instructor,index)=>( 
                                    <li key={`${index}-ins`}>{instructor.username}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className="pe-row">
                        <div className="pe-col-6">
                            <label className="pe-label--bold">{COURSE_DETAILS.INSTITUTION_NAME} </label>
                        </div>
                        <div className="pe-col-6">
                            <label className="pe-label">{courses.organizationName}</label>
                        </div>
                    </div>
                    <div className="pe-row">
                        <div className="pe-col-6">
                            <label className="pe-label--bold">{COURSE_DETAILS.ORGANIZATION_ID} </label>
                        </div>
                        <div className="pe-col-6">
                            <label className="pe-label">{courses.organizationId}</label>
                        </div>
                    </div>
                    <div className="pe-row">
                        <div className="pe-col-6">
                            <label className="pe-label--bold">{COURSE_DETAILS.COPYABLE}</label>
                        </div>
                        <div className="pe-col-6">
                            <label className="pe-label">{courses.metadata.copyable?"Yes":"No"}</label>
                        </div>
                    </div>
                    <div className="pe-row">
                        <div className="pe-col-6">
                            <label className="pe-label--bold">{COURSE_DETAILS.COPY_SOURCE_ID}</label>
                        </div>
                        <div className="pe-col-6">
                            <label className="pe-label">{courses.copySourceId}</label>
                        </div>
                    </div>
                    <div className="pe-row">
                        <div className="pe-col-6">
                            <label className="pe-label--bold">{COURSE_DETAILS.ACTIVE_INSTRUCTOR_COUNT}</label>
                        </div>
                        <div className="pe-col-6">
                            <label className="pe-label">{courses.registrationCounts && courses.registrationCounts.hasOwnProperty('instructor') ? courses.registrationCounts.instructor.active : ''}</label>
                        </div>
                    </div>
                    <div className="pe-row">
                        <div className="pe-col-6">
                            <label className="pe-label--bold">{COURSE_DETAILS.ACTIVE_STUDENT_COUNT}</label>
                        </div>
                        <div className="pe-col-6">
                            <label className="pe-label">{courses.registrationCounts && courses.registrationCounts.hasOwnProperty('student') ? courses.registrationCounts.student.active : ''}</label>
                        </div>
                    </div>
                    <div className="pe-row">
                        <div className="pe-col-6">
                            <label className="pe-label--bold">{COURSE_DETAILS.COURSE_CREATE_DATE}</label>
                        </div>
                        <div className="pe-col-6">
                            <label className="pe-label">{courses.createdAt ? Moment.utc(courses.createdAt).format('YYYY-MM-DD') : ''}</label>
                        </div>
                    </div>
                    <div className="pe-row">
                        <div className="pe-col-6">
                            <label className="pe-label--bold">{COURSE_DETAILS.COURSE_START_DATE}</label>
                        </div>
                        <div className="pe-col-6">
                            <label className="pe-label">{Moment.utc(courses.startDate).format('YYYY-MM-DD')}</label>
                        </div>
                    </div>
                    <div className="pe-row alignitem-center">
                        <div className="pe-col-6">
                            <label className="pe-label--bold">{COURSE_DETAILS.COURSE_END_DATE}</label>
                        </div>
                        <div className="pe-col-4">
                            <CourseDetailsDatePicker options={{ courses, index, courseEndDateChangeHandler: this.courseEndDateChangeHandler }} key={this.state.reloadKeyForDateChange} hasPrivateResources={this.props.hasPrivateResources}/>
                        </div>
                    </div>
                    <div className="pe-row alignitem-center">
                        <div className="pe-col-6">
                            <label className="pe-label--bold">{COURSE_DETAILS.ADD_NEW_INSTRUCTOR}</label>
                        </div>
                        <div className="pe-col-4">
                            <div className="instructor-container">
                                <input className="instructor-name" placeholder="Instructor username" name="instructor_name" value={this.state.instructor_name.hasOwnProperty(courses.id) ? this.state.instructor_name[courses.id] : ''} onChange={(e)=>this.instructorChangeHandler(e,courses.id)}/>
                                {this.state.instructor_name.hasOwnProperty(courses.id) && this.state.instructor_name[courses.id] && <div className="save-options">
                                    <button className="save-button" onClick={() => this.addNewInstructorName(courses.id, index)}><span><Svg svgString='check-sm-18' /></span></button>
                                    <button className="cancel-button" onClick={() => this.clearInstructorName(courses.id)}><span><Svg svgString='remove-sm-18' /></span></button>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </CourseDetailsHeader>))}
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/CourseDetails.js